import React, { ReactElement, useState } from 'react'
import { Select, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import { debounce } from '@/utils/util'
import type { IOrganPersonInfo } from '@/store/models/organStructure.model'
import { getOrganPersonName } from '@/services/organStructure.service'

interface IProps {
    value?: string
    mode?: 'multiple' | 'tags';
    placeholder?: string;
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    onChange: <T>(e: T) => void
}

const SelectOrganPerson = (props: IProps): ReactElement => {
    const { value, mode, placeholder, onChange } = props
    const [searchLoading, setSearchLoading] = useState(false)
    const [organPersonList, setOrganPersonList] = useState<IOrganPersonInfo[]>([])
    const { t, i18n } = useTranslation()
    const { Option } = Select

    const getOrganListFn = async (searchVal: string) => {
        const res = await getOrganPersonName(searchVal).finally(() => {
            setSearchLoading(false)
        })
        console.log('getOrganPersonName: ', res)
        setOrganPersonList(res.content)
    }

    const onSearchPerson = debounce((searchVal: string): void => {
        if (searchVal.startsWith('u')) {
            if (searchVal.length > 6) {
                setSearchLoading(true)
                getOrganListFn(searchVal)
            }
        } else if (searchVal !== '') {
            setSearchLoading(true)
            getOrganListFn(searchVal)
        } else {
            setOrganPersonList([])
        }
    })

    // useEffect(() => {
    //     if (value) {
    //         getOrganListFn(value)
    //     }
    // }, [value])

    return (
        <Select showSearch allowClear
            mode={mode}
            value={value}
            loading={searchLoading}
            filterOption={false}
            placeholder={placeholder ?? (t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') + t('organPerson') + (i18n.language !== 'zh' ? ' ' : '') + ', ' + t('organPersonTips'))}
            onSearch={onSearchPerson}
            notFoundContent={searchLoading ? <Spin size="small" /> : null}
            onChange={(selectValue: string) => {
                if (!mode) {
                    const findObj = organPersonList.find(item => item.nickName === selectValue)
                    onChange({
                        userId: findObj?.userId,
                        nickName: findObj?.nickName,
                        login: findObj?.login,
                        avatar: findObj?.avatar,
                        email: findObj?.email,
                    })
                } else {
                    onChange(selectValue)
                }
            }}
        >
            {organPersonList.map((item: IOrganPersonInfo) => (<Option key={item.userId} value={item.nickName}>
                {item.nickName}
            </Option>))}
        </Select>
    )
}

export default SelectOrganPerson
